'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTrashOutline = function IoIosTrashOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31 8.8v1.2h-1.6l-1.8 22.7c0 1.3-1.1 2.3-2.3 2.3h-11c-1.3 0-2.3-1-2.3-2.3l-1.9-22.7h-1.6v-1.2h6.2v-1.5c0-1.3 1.1-2.3 2.3-2.3h5.5c1.2 0 2.2 1 2.2 2.3v1.5h6.3z m-15.1-1.5v1.5h7.7v-1.5c0-0.7-0.5-1.1-1.1-1.1h-5.5c-0.6 0-1.1 0.4-1.1 1.1z m10.6 25.4l1.8-22.7h-17l1.8 22.7v0c0 0.7 0.6 1.1 1.2 1.1h11c0.6 0 1.2-0.4 1.2-1.1v0z m-7.3-1.4v-18.8h1.1v18.8h-1.1z m5.6-18.8l-0.9 18.8h-1.1l0.8-18.8h1.2z m-9 0l0.9 18.8h-1.1l-0.8-18.8h1z' })
        )
    );
};

exports.default = IoIosTrashOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-trash-outline.js
// module id = 2337
// module chunks = 0